import { render } from "./CharacterDetail.vue?vue&type=template&id=9ed5c90a&scoped=true"
import script from "./CharacterDetail.vue?vue&type=script&lang=ts"
export * from "./CharacterDetail.vue?vue&type=script&lang=ts"

import "./CharacterDetail.vue?vue&type=style&index=0&id=9ed5c90a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9ed5c90a"

export default script